import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

const Root = styled.div`
  p {
    color: ${(props) => props.theme.colors.primary};
  }
`;

const Home = () => {
  const [guId, setGuId] = useState('');
  const navigate = useNavigate();

  const methodDoesNotExist = (): void => {
    throw new Error('Function not implemented.');
  };

  useEffect(() => {
    setGuId('52671ef0-1393-11ee-a262-029e6023fd69');
  }, []);

  useEffect(() => {
    if (guId) {
      navigate(`/plaid?guid=${guId}`);
    }
  }, [guId]);

  return (
    <Root className="App">
      <header className="App-header">
        <p>Tifle Contact</p>
        <button onClick={() => methodDoesNotExist()} type="submit">
          Click to trigger sentry error
        </button>
      </header>
    </Root>
  );
};

export default Home;
